import {
  AssetService,
  EdtellCommentsModule,
  EdtellContainersModule,
  EdtellHeaderModule,
  EdtellMaterialModule,
  EdtellPortalModule,
  EdtellUtilitiesModule,
  ErrorInterceptor,
  JwtInterceptorProvider,
  LoginInterceptorProvider,
  NotificationService,
  SrsSearchBarModule,
  SrsSearchService,
  SrsSidebarModule,
} from "@edtell-common";
import { CommonModule } from "@angular/common";
import {} from "@angular/common/http";
import { Injector, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { CatalogSearch } from "../../modules/catalog/services/catalog.search";
import { CustomerSearch } from "../../modules/customer/services/customer.search";
import { ObjectSearch } from "../../modules/admin/services/object.search";
import { UserSearch } from "../../modules/admin/services/users.search";
import { APP_CONTAINER_ROUTING } from "./app-container.routing";
import { AppContainerComponent } from "./components/app-container.component";
import { HeaderComponent } from "../header/header.component";
import { ProviderSearch } from "../../modules/providers/services/provider.search";
import { RegistrationHeaderComponent } from "../../modules/registrations/components/registration-header/registration-header.component";
import { RegistrationSearch } from "../../modules/registrations/searches/registration.search";
import { EnrollmentHeaderComponent } from "../../modules/enrollment/components/enrollment-header/enrollment-header.component";
import { BlockFromGoogleGuard } from "../../modules/enrollment/guards/block-from-google.guard";
import { EdtellFooterModule } from "../../modules/edtell-common/edtell-footer/edtell-footer.module";

export function searchFactory(router: Router, injector: Injector) {
  const Service = SrsSearchService.withSearches([]);
  return new Service(router, injector);
}

@NgModule({
  declarations: [AppContainerComponent, HeaderComponent],
  imports: [
    APP_CONTAINER_ROUTING,
    CommonModule,
    FormsModule,
    EdtellUtilitiesModule,
    SrsSearchBarModule.withSearches([
      CustomerSearch,
      UserSearch,
      ObjectSearch,
      CatalogSearch,
      ProviderSearch,
      RegistrationSearch,
    ]),
    SrsSidebarModule,
    EdtellContainersModule,
    EdtellCommentsModule,
    EdtellMaterialModule,
    EdtellPortalModule,
    EdtellHeaderModule.withComponents([
      HeaderComponent,
      EnrollmentHeaderComponent,
      RegistrationHeaderComponent,
    ]),
    EdtellFooterModule,
  ],
  providers: [
    ErrorInterceptor,
    AssetService,
    CustomerSearch,
    UserSearch,
    ObjectSearch,
    CatalogSearch,
    ProviderSearch,
    BlockFromGoogleGuard,
  ],
})
export class AppContainerModule {}
